<template>
    <div class="intro-container">
        <Logo />
        <div class="project-intro">
            <div class="project-intro-bg bg1">
                <img src="../assets/images/bg1.png" >
            </div>
            <div class="project-intro-bg bg2">
                <img src="../assets/images/bg2.png" >
            </div>
            <div class="project-title-pic">
                <img src="../assets/images/png_title1.png" >
            </div>
            <div class="project-video" @click="ImagePreview">
                <div class="project-video-img">
                    <img src="../assets/images/png_3d.png" >
                </div>
            </div>
            <div class="project-title-pic">
                <img src="../assets/images/png_title2.png" >
            </div>
            <div class="project-video" @click="playVideo">
                <div class="project-video-img">
                    <img :src="projectVideo.cover_url" >
                </div>
                <div class="project-video-play">
                    <img src="../assets/images/btn_start.png" >
                </div>
            </div>
        </div>
        <div class="project-intro">
            <div class="project-title-pic">
                <img src="../assets/images/png_title3.png" >
            </div>
            <div class="initial-stage">
                <div class="initial-stagetop">适用于准备创业/创业初期</div>
                <div class="initial-stagebox">
                    <van-collapse v-model="activeNames" accordion>
                        <div class="stagebox-type">适用各类群体</div>
                        <van-collapse-item title="产生你的企业想法--GYB" name="1">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">GYB课程旨在帮助创业者了解什么是企业，什么是企业想法， 分析评估自己是否适合创办企业，通过掌握产生企业 想法的方法产生很多的创业项目， 并从中筛选、分析、确认最适合自己的创业项目。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course1.png" >
                                </div>
                            </div>
                        </van-collapse-item>
                        <van-collapse-item title="创办你的企业-SYB" name="2">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">SYB课程旨在帮助创业者在培训的过程中演练实施开办企业的各个步骤，完成自己的创业计划书，建立有生存能力的小微企业。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course2.png" >
                                </div>
                            </div>
                        </van-collapse-item>
                        <van-collapse-item title="网络创业培训（电商版）" name="3">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">网络创业培训是继SIYB项目之后自主开发的新项目。通过理论+训练+实践的培训模式，使创业者了解电商创业形势， 找到电商创业机会，并在实践中完成项目选择、市场分析、开办准备、运营管理和运营优化。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course5.png" >
                                </div>
                            </div>
                        </van-collapse-item>
                        <div class="stagebox-type">大学生</div>
                        <van-collapse-item title="创办你的企业（大学生）" name="4">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">旨在帮助有创业愿望并具备一定创业条件的大学生接受有针对性地创业培训，从而发现自己是否适合创办企业，适合创办什么样的企业，衡量创业想法是否现实可行，最终完成自己的创业计划书。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course7.png" >
                                </div>
                            </div>
                        </van-collapse-item>
                        <van-collapse-item title="创业（模拟）实训" name="5">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">旨在帮助创业者学员在模拟商业环境中，进行企业创建和企业经营管理等创业活动，积累实践经验，增强创业能力，降低创业风险，提高创业成功率和企业存活率。</div>
                            </div>
                        </van-collapse-item>
                        <div class="stagebox-type">职业院校（技工院校）</div>
                        <van-collapse-item title="技能+创业创新" name="6">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                        </van-collapse-item>
                        <div class="stagebox-type">返乡入乡创业人员、创业致富带头人</div>
                        <van-collapse-item title="乡村创业培训课程" name="7">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">旨在帮助乡村创业者了解市场规律，掌握经营技巧，推动农产品的优化、升级，走规模化、品牌化的道路，进而不断提高农业创业的经营效益，让乡村创业有方法可依，有路径可循。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course6.png" >
                                </div>
                            </div>
                        </van-collapse-item>
                        <!-- <div class="stagebox-type">退役军人、残疾人、失业人员</div>
                        <van-collapse-item title="产生企业想法（GYB）" name="13">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">GYB课程旨在帮助创业者了解什么是企业，什么是企业想法， 分析评估自己是否适合创办企业，通过掌握产生企业 想法的方法产生很多的创业项目， 并从中筛选、分析、确认最适合自己的创业项目。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course1.png" >
                                </div>
                            </div>
                        </van-collapse-item>
                        <van-collapse-item title="创办你的企业（SYB）" name="14">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">SYB课程旨在帮助创业者在培训的过程中演练实施开办企业的各个步骤，完成自己的创业计划书，建立有生存能力的小微企业。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course2.png" >
                                </div>
                            </div>
                        </van-collapse-item> -->
                    </van-collapse>
                </div>
            </div>
            <div class="initial-stage already">
                <div class="initial-stagetop">适用已经创业阶段</div>
                <div class="initial-stagebox">
                    <van-collapse v-model="activeNames" accordion>
                        <div class="stagebox-type">适用各类群体</div>
                        <van-collapse-item title="改善你的企业（IYB）" name="8">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">IYB课程旨在帮助小企业家系统地建立企业的基本管理体系，制定企业的营销计划，完善企业的采购系统，规范企业 的存货管理，核算控制企业的成本，建立企业的记账体系， 制定企业的改善计划，完善人力资源和生产管理，最终通过综合企业管理能力的提升，改善并提高企业的赢利能力和市场竞争能力。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course3.png" >
                                </div>
                            </div>
                        </van-collapse-item>
                        <van-collapse-item title="扩大你的企业（EYB）" name="9">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">EYB课程旨在帮助发展到一定阶段、希望企业实现战略性飞跃的微小企业主突破企业增长瓶颈， 分析并选择出符合企业自身情况的企业增长战略，并以此指导企业增长战略的实施，实现企业扩大的目标。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course4.png" >
                                </div>
                            </div>
                        </van-collapse-item>
                        <div class="stagebox-type">返乡入乡创业人员、创业致富带头人</div>
                        <van-collapse-item title="农产电商课程" name="10">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                        </van-collapse-item>
                        <van-collapse-item title="农旅融合课程" name="11">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                        </van-collapse-item>
                        <van-collapse-item title="农艺文创课程" name="12">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                        </van-collapse-item>
                        <!-- <div class="stagebox-type">退役军人、残疾人、失业人员</div>
                        <van-collapse-item title="改善你的企业（IYB）" name="15">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">IYB课程旨在帮助小企业家系统地建立企业的基本管理体系，制定企业的营销计划，完善企业的采购系统，规范企业 的存货管理，核算控制企业的成本，建立企业的记账体系， 制定企业的改善计划，完善人力资源和生产管理，最终通过综合企业管理能力的提升，改善并提高企业的赢利能力和市场竞争能力。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course3.png" >
                                </div>
                            </div>
                        </van-collapse-item>
                        <van-collapse-item title="扩大你的企业（EYB）" name="16">
                            <template #right-icon>
                                <van-icon class="icon-collapse iconfont icon-btn_"/>
                            </template>
                            <div class="stagebox-content">
                                <div class="stagebox-text">EYB课程旨在帮助发展到一定阶段、希望企业实现战略性飞跃的微小企业主突破企业增长瓶颈， 分析并选择出符合企业自身情况的企业增长战略，并以此指导企业增长战略的实施，实现企业扩大的目标。</div>
                                <div class="stagebox-pic">
                                    <img src="../assets/images/course4.png" >
                                </div>
                            </div>
                        </van-collapse-item> -->
                    </van-collapse>
                </div>
            </div>
        </div>
        <van-overlay :show="isShow">
            <div class="video-close" @click="closeVideo">
                <img src="../assets/images/close.ss.png">
            </div>
            <div class="video-box">
                <video oncontextmenu="return false" width="100%" height="100%" ref="videoPlayer" :src="projectVideo.video_url" :poster="projectVideo.cover_url" controls controlslist="nodownload" disablePictureInPicture></video>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { getVideo } from "../api/index"
import Logo from "../components/Logo"
import { ImagePreview } from 'vant'
export default {
    name: 'projectIntro',
    data() {
        return {
            showRoom: [
                require("@/assets/images/1.jpg"),
                require("@/assets/images/2.jpg"),
                require("@/assets/images/3.jpg"),
                require("@/assets/images/4.jpg"),
                require("@/assets/images/5.jpg"),
                require("@/assets/images/6.jpg"),
                require("@/assets/images/7.jpg"),
                require("@/assets/images/8.jpg"),
                require("@/assets/images/9.jpg"),
                require("@/assets/images/10.jpg")
            ],
            isShow: false,
            activeNames: '1',
            projectVideo: {}
        }
    },
    components: {
        Logo
    },
    created() {
        this.getVideo()
    },
    methods: {
        getVideo(){
            getVideo().then(res=>{
                if(res.code == 200){
                    let videoData = res.data.list
                    this.projectVideo = videoData.filter(pilot => pilot.type === 1)[0]
                }
            }).catch({})
        },
        playVideo() {
            this.isShow = true
        },
        closeVideo() {
            this.isShow = false
            this.$refs.videoPlayer.pause();
        },
        ImagePreview() {
            ImagePreview(this.showRoom);
        },
    }
}
</script>
<style lang="scss" scoped>
.project-intro{
    position: relative;
    padding: 0 24px 48px;
    .project-intro-bg{
        position: absolute;
        width: 100%;
        left: 0;
        z-index: -1;
        &.bg1{
            top: 0;
            bottom: 60%;
        }
        &.bg2{
            top: 40%;
            bottom: 0;
        }
        img{
            display: block;
            width: 100%;
            height: 100%;
        }
    }
    .project-title-pic{
        text-align: center;
        padding: 32px 0;
        img{
            display: inline-block;
            vertical-align: top;
            height: 52px;
        }
    }
    .project-video{
        position: relative;
        border-radius: 16px;
        .project-video-img{
            img{
                display: block;
                width: 100%;
                height: 395px;
            }
        }
        .project-video-play{
            position: absolute;
            width: 122px;
            height: 122px;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            img{
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }
    .initial-stage{
        &.already{
            margin-top: 48px;
            .initial-stagetop{
                background-color: #5880EC;
            }
            .initial-stagebox{
                background-color: #5880EC;
            }
        }
        .initial-stagetop{
            font-size: 32px;
            color: #fff;
            line-height: 80px;
            padding: 0 16px;
            background-color: #45A9F3;
            border-radius: 16px 16px 0px 0px;
            margin-bottom: 8px;
        }
        .initial-stagebox{
            background-color: #45A9F3;
            padding: 14px 16px 16px;
            .van-hairline--top-bottom{
                &::after{
                    border-width: 0;
                }
            }
            .stagebox-type{
                font-size: 28px;
                color: #fff;
                padding: 16px 0 20px;
            }
            .icon-collapse{
                color: #45A9F3;
                font-size: 45px;
                transition: transform .3s,-webkit-transform .3s;
            }
            .van-collapse-item__title--expanded{
                .icon-collapse{
                    transform: rotate(-180deg);
                }
            }
            ::v-deep.van-collapse-item__content{
                padding-top: 8px;
                padding-bottom: 28px;
            }
            .stagebox-content{
                display: flex;
                .stagebox-text{
                    flex: 1;
                    font-size: 28px;
                    color: #666;
                    line-height: 46px;
                }
                .stagebox-pic{
                    width: 158px;
                    margin-left: 42px;
                    img{
                        display: block;
                        width: 100%;
                    }
                }
            }
            .van-collapse-item{
                margin-bottom: 24px;
                border-radius: 8px;
                overflow: hidden;
                ::v-deep.van-cell{
                    line-height: initial;
                    .van-cell__title{
                        font-size: 32px;
                        color: #333;
                    }
                    &::after{
                        content: "";
                        border-bottom: 0;
                    }
                }
            }
        }
    }
}
.video-close{
    position: absolute;
    width: 84px;
    height: 84px;
    right: 0;
    top: 0;
    margin: auto;
    img{
        display: block;
        width: 48px;
        height: 48px;
        margin-top: 18px;
        margin-left: 18px;
    }
}
.video-box{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 84px;
    margin: auto;
}
</style>
